import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  link: {
    font: 'inherit',
    color: theme.colors.button__background_secondary || theme.colorPalette.orange_50,
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:disabled': {
      color: theme.colorPalette.beige_70,
      cursor: 'default'
    }
  }
}));
